import { render, staticRenderFns } from "./allocate-promotion-to-parking-lot-dialog.vue?vue&type=template&id=4b29f62e&scoped=true"
import script from "./allocate-promotion-to-parking-lot-dialog.vue?vue&type=script&lang=js"
export * from "./allocate-promotion-to-parking-lot-dialog.vue?vue&type=script&lang=js"
import style0 from "./allocate-promotion-to-parking-lot-dialog.vue?vue&type=style&index=0&id=4b29f62e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b29f62e",
  null
  
)

export default component.exports